import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO__user_credentials } from '@shared/dto/+user/auth/DTO__user_credentials';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { StateUser } from '../../state_user';
import { try_set_is_authorized } from '../_methods/try_set_is_authorized';

export const REMOTE__user_auth_login_with_email_and_password = createAsyncThunkSafe<
  DTO_RESPONSE__auth_success | DTO_RESPONSE__error,
  { credentials: DTO__user_credentials }
>(
  ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_EMAIL_AND_PASSWORD,
  async ({ credentials }): Promise<DTO_RESPONSE__auth_success | DTO_RESPONSE__error> => {
    let response = await send_to_server<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>(
      ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_EMAIL_AND_PASSWORD,
      credentials,
    );
    return response;
  },
);

export function INIT_REMOTE__user_auth_login_with_email_and_password(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(REMOTE__user_auth_login_with_email_and_password.pending, state => {})
    .addCase(REMOTE__user_auth_login_with_email_and_password.rejected, (state, action) => {})
    .addCase(REMOTE__user_auth_login_with_email_and_password.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>) => {
      try_set_is_authorized(state, action.payload);
    });
}
